export default __webpack_public_path__ + "static/media/GOOG.1f40c812.png";